import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { AssetChubbBookingBanner } from '@asset-chubb-booking-banner';
import { ReservationType } from '@user-history/entities/user-history-item';

export function isActivePaidChubbAssistanceByBooking(bookingType: TravelBookingType): boolean {
  return !!AssetChubbBookingBanner?.ENABLED_ASSISTANCE_INTERFACE?.includes(bookingType);
}

export function isActivePaidChubbAssistanceByHistoryDetail(type: ReservationType): boolean {
  return !!AssetChubbBookingBanner?.ENABLED_ASSISTANCE_INTERFACE_DETAIL?.includes(type);
}

